<template>
	<div id="investors-table">
		<table class="table" v-if="tableRows.length != 0 && !isLoadingInvestors">
			<thead class="table__header">
				<tr>
					<th
						v-for="(header, index) in tableHeader"
						@click="orderByHeader(header, index)"
						:class="header.field == 'edit' || header.field == 'delete' ? 'icon' : ''"
						:key="index"
					>
						<div class="row">
							<span :class="header.field == 'actions' ? '' : 'pointer'">{{ header.label }}</span>
							<SortUpDown
								v-if="header.field !== 'actions'"
								:isActive="header.isActive"
								:alt="'Ordenar por ' + header.label"
							/>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(row, index) in tableRows"
					:key="row.id"
					:class="[index % 2 == 0 ? 'stripped' : '', row.isInvalid ? 'invalid' : '']"
				>
					<td>{{ row.name }}</td>
					<td>
						{{ row.cnpj != null ? formatCnpj(row.cnpj) : ' - ' }}
					</td>
					<td>
						{{ row.fantasyName != null ? row.fantasyName : ' - ' }}
					</td>
					<td>
						{{ row.hasNDA ? 'Aprovado' : 'Pendente' }}
					</td>
					<td class="actions">
						<span @click="editRow(row)"><EditIcon :size="24" :border="'#0047ff'" /></span>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="loader" v-if="isLoadingInvestors">
			<SpinnerIcon :color="'#597393'" />
		</div>
		<Pagination
			v-if="tableRows.length != 0 && !isLoadingInvestors"
			:totalPages="totalPages"
			:currentFromReq="currentPage"
			@tableRequest="tableRequest"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import Pagination from '@/components/shared/Pagination/Pagination';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon';
import SortUpDown from '@/components/shared/Icons/SortUpDown.vue';
import EditIcon from '@/components/shared/Icons/EditIcon.vue';

export default {
	name: 'Table',
	components: {
		SidebarArrow,
		Pagination,
		SpinnerIcon,
		SortUpDown,
		EditIcon,
	},
	props: {
		isWeb: {
			required: true,
		},
		currentPage: {
			required: true,
		},
	},
	data: () => ({
		tableHeader: [
			{
				field: 'name',
				label: 'Investidores',
				isActive: null,
			},
			{
				field: 'cnpj',
				label: 'CNPJ',
				isActive: null,
			},
			{
				field: 'fantasyName',
				label: 'Nome Fantasia',
				isActive: null,
			},
			{
				field: 'hasNDA',
				label: 'NDA',
				isActive: null,
			},
			{
				field: 'actions',
				label: 'Ações',
				isActive: null,
			},
		],
	}),
	mounted() {},
	methods: {
		formatCnpj(param) {
			let cpnj = param.replace(/[^\w\s]/gi, '');
			return cpnj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
		},
		tableRequest(param) {
			this.$emit('changePage', param);
		},
		orderByHeader(param, index) {
			if (param.field == 'actions') return;
			this.setArrowIcon(index);
			this.$emit('orderByHeader', param.field);
		},
		setArrowIcon(index) {
			if (this.tableHeader[index].isActive === null) {
				this.tableHeader[index].isActive = false;
			} else {
				this.tableHeader[index].isActive = !this.tableHeader[index].isActive;
			}
			this.tableHeader = this.tableHeader.map((el, idx) => {
				if (idx !== index) {
					el.isActive = null;
				}
				return el;
			});
		},
		editRow(row) {
			this.$router.push({
				path: '/dashboard/investor/detail',
				query: { id: row.id },
			});
		},
	},
	computed: {
		...mapGetters('investorManagement', ['investorList', 'isLoadingInvestors']),
		tableRows() {
			const rows = this.investorList.investors != undefined ? this.investorList.investors : [];

			return !rows.length ? [] : rows;
		},
		totalPages() {
			const pagination =
				this.investorList.totalPages != undefined ? this.investorList.totalPages : 1;

			return pagination;
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'Table.scss';
</style>
